'use client'

import { FeaturedCard } from '@/components/ui/featured-card'
import type { ResolvedResource } from './index'

interface Props {
  resource: ResolvedResource
  variant?: 'light' | 'dark'
}

export function RelatedResourceCard({ resource, variant = 'light' }: Props) {
  const isDark = variant === 'dark'

  return (
    <FeaturedCard
      title={resource.title}
      href={resource.href}
      variant={variant}
      topContent={
        <div className="flex items-center">
          <span
            className={`px-1.5 py-1 rounded-[4px] body-small font-medium text-black border transition-colors duration-300 ${
              isDark
                ? 'bg-white border-black'
                : 'bg-civo-cloud border-black group-hover:bg-white'
            }`}
          >
            {resource.categoryLabel}
          </span>
        </div>
      }
    />
  )
}
